var _path, _path2, _path3, _path4, _g, _rect, _rect2, _rect3, _rect4, _path5, _rect5, _path6, _rect6, _rect7, _path7, _rect8, _rect9, _path8, _rect10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCertificationNew4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 150,
    viewBox: "0 0 216 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 45.8973H122.422V123.599H0V45.8973Z",
    fill: "#99C4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7267 84.7524L122.422 45.7812L122.422 123.724L63.7267 84.7524Z",
    fill: "#B4D6FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6957 84.7524L9.39254e-06 45.7812L5.98558e-06 123.724L58.6957 84.7524Z",
    fill: "#B4D6FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4182 89.7331C66.0047 95.3559 56.4176 95.3559 50.0042 89.7331L7.04138e-06 45.8938H122.422L72.4182 89.7331Z",
    fill: "#E0EEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2723_1294)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.4348,
    y: 0.304688,
    width: 100.088,
    height: 132.713,
    rx: 4,
    fill: "#F4F4F4"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.868,
    y: 59.1094,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 102.868,
    y: 71.4141,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 102.868,
    y: 83.7188,
    width: 65.2504,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 102.868,
    y: 96.0312,
    width: 46.8893,
    height: 3.3063,
    rx: 1.65315,
    fill: "#DFDFDF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.773 29.8105V41.3633H122.211V35.5869H121.132V40.8047H119.609V30.001H121.132V34.2793H122.211V29.8105H123.773ZM114.277 38.5449V31.0928H115.902V37.1294C116.828 37.104 117.85 37.0215 118.961 36.8057L119.126 38.2021C117.577 38.4688 116.257 38.5513 115.064 38.5449H114.277ZM135.579 35.2822V36.5771H125.042V35.2822H127.416V33.8984C126.572 33.5239 126.096 32.9526 126.096 32.21C126.096 30.8135 127.74 29.9819 130.311 29.9756C132.863 29.9819 134.507 30.8135 134.513 32.21C134.507 32.9653 134.018 33.543 133.155 33.9111V35.2822H135.579ZM126.248 39.2559C126.248 37.9229 127.765 37.1802 130.298 37.1865C132.793 37.1802 134.31 37.9229 134.322 39.2559C134.31 40.6206 132.793 41.3506 130.298 41.3506C127.765 41.3506 126.248 40.6206 126.248 39.2559ZM127.784 32.21C127.772 32.8447 128.679 33.1685 130.311 33.1621C131.923 33.1685 132.837 32.8447 132.837 32.21C132.837 31.5625 131.923 31.2197 130.311 31.2197C128.679 31.2197 127.772 31.5625 127.784 32.21ZM127.899 39.2559C127.892 39.8462 128.698 40.1445 130.298 40.1445C131.866 40.1445 132.691 39.8462 132.697 39.2559C132.691 38.6846 131.866 38.4116 130.298 38.4053C128.698 38.4116 127.892 38.6846 127.899 39.2559ZM129.054 35.2822H131.542V34.311C131.161 34.3618 130.749 34.3809 130.311 34.3809C129.86 34.3809 129.441 34.3555 129.054 34.311V35.2822ZM146.815 35.1299V36.4375H136.278V35.1299H146.815ZM136.747 33.4414C138.918 33.2446 140.105 32.4512 140.372 31.6387H137.242V30.3438H145.863V31.6387H142.708C142.968 32.4448 144.149 33.2446 146.37 33.4414L145.799 34.7109C143.615 34.5015 142.149 33.6763 141.533 32.5591C140.924 33.6763 139.47 34.5015 137.28 34.7109L136.747 33.4414ZM137.484 39.2305C137.484 37.8721 139.007 37.085 141.533 37.085C144.041 37.085 145.545 37.8721 145.558 39.2305C145.545 40.5952 144.041 41.3696 141.533 41.3633C139.007 41.3696 137.484 40.5952 137.484 39.2305ZM139.134 39.2305C139.128 39.8271 139.934 40.1064 141.533 40.1064C143.101 40.1064 143.926 39.8271 143.933 39.2305C143.926 38.6274 143.101 38.3418 141.533 38.3418C139.934 38.3418 139.128 38.6274 139.134 39.2305ZM157.25 29.8105V36.5771H155.638V35.1045H153.48V35.9424H147.995V30.6611H153.48V31.499H155.638V29.8105H157.25ZM149.328 39.1289C149.328 37.707 150.839 36.8755 153.302 36.8818C155.771 36.8755 157.282 37.707 157.288 39.1289C157.282 40.5571 155.771 41.3696 153.302 41.3633C150.839 41.3696 149.328 40.5571 149.328 39.1289ZM149.608 34.6602H151.893V31.9434H149.608V34.6602ZM150.941 39.1289C150.941 39.7891 151.772 40.1318 153.302 40.1318C154.838 40.1318 155.67 39.7891 155.676 39.1289C155.67 38.4434 154.838 38.1133 153.302 38.1133C151.772 38.1133 150.941 38.4434 150.941 39.1289ZM153.48 33.7969H155.638V32.7812H153.48V33.7969Z",
    fill: "#374969"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 138.425,
    y: 114.602,
    width: 60.855,
    height: 11.5131,
    fill: "#56BA74"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M199.28 114.602H211.342V126.115H199.28V114.602Z",
    fill: "#4A935E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 163.645,
    y: 114.055,
    width: 10.4166,
    height: 12.6096,
    fill: "#CAEADB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 142.264,
    y: 137.625,
    width: 60.855,
    height: 11.5131,
    fill: "#56BA74"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.118 137.625H215.179V149.138H203.118V137.625Z",
    fill: "#4E9A63"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 167.482,
    y: 137.078,
    width: 10.4166,
    height: 12.6096,
    fill: "#CAEADB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 132.395,
    y: 126.117,
    width: 60.855,
    height: 11.5131,
    fill: "#49AF68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M193.25 126.117H205.312V137.63H193.25V126.117Z",
    fill: "#2A7940"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 157.614,
    y: 125.57,
    width: 10.4166,
    height: 12.6096,
    fill: "#C6E0D4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2723_1294",
    x: 85.4348,
    y: 0.304688,
    width: 108.087,
    height: 140.711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2723_1294"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2723_1294",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCertificationNew4);
export default __webpack_public_path__ + "static/media/IcCertificationNew4.b57efef15a408de20aec9135fbfcc836.svg";
export { ForwardRef as ReactComponent };